import { Injectable } from "@angular/core";
import * as CryptoJS from 'crypto-js';

@Injectable({
    providedIn: 'root'
})
export class DataEncryptDecryptService {

    constructor() {

    }
    
    encryption(plainText: any) {
        var b64 = CryptoJS.AES.encrypt(plainText, 'default').toString();
        var e64 = CryptoJS.enc.Base64.parse(b64);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return eHex;
    }
    
    decryption(cipherText: any) {
        var reb64 = CryptoJS.enc.Hex.parse(cipherText);
        var bytes = reb64.toString(CryptoJS.enc.Base64);
        var decrypt = CryptoJS.AES.decrypt(bytes, 'default');
        var plain = decrypt.toString(CryptoJS.enc.Utf8);
        return plain;
    }

}